import React from 'react';
import { Link } from 'react-router-dom';
import CharacterItem from './CharacterItem';

const CharacterList = ({ characters = [], isLoading }) => {
  return (
    <div className="favorites-card">
      <div className="favorites-header">
        <h3>Favorite Characters</h3>
        <Link to="/characters" className="see-all-link">See All</Link>
      </div>
      
      <div className="favorites-list">
        {isLoading ? (
          <div className="favorites-loading">Loading your favorite characters...</div>
        ) : characters.length === 0 ? (
          <div className="favorites-loading">
            You haven't added any favorite characters yet
          </div>
        ) : (
          characters.map(character => (
            <CharacterItem key={character._id} character={character} />
          ))
        )}
      </div>
    </div>
  );
};

export default CharacterList;